module.exports = __webpack_public_path__ + "img/banner_publish_text.0f59c681.png";